import { Component, EventEmitter, Input, OnDestroy, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import Cropper from 'cropperjs';
import { SafeUrl } from '@angular/platform-browser';

export interface CropperOutputOptions {
  mimeType: string;
  qualityArgument: number;
}

export interface CropperOptions extends Cropper.Options {
  minCropWidth: number;
  minCropHeight: number;
  outputOptions: CropperOutputOptions;
}

@Component({
  selector: 'lib-cropper',
  template: `<div class="cropper-component" *ngIf="dataUrl">
  <img #image alt="image" [src]="dataUrl" (load)="onImageLoad($event)"/>
</div>
`,
  styles: [`.cropper-component img{max-width:100%;max-height:100%}::ng-deep{/*!
 * Cropper.js v1.4.0
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2018-06-01T15:18:09.891Z
 */}::ng-deep .cropper-container{direction:ltr;font-size:0;line-height:0;position:relative;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}::ng-deep .cropper-container img{display:block;height:100%;image-orientation:0deg;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}::ng-deep .cropper-canvas,::ng-deep .cropper-crop-box,::ng-deep .cropper-drag-box,::ng-deep .cropper-modal,::ng-deep .cropper-wrap-box{bottom:0;left:0;position:absolute;right:0;top:0}::ng-deep .cropper-canvas,::ng-deep .cropper-wrap-box{overflow:hidden}::ng-deep .cropper-drag-box{background-color:#fff;opacity:0}::ng-deep .cropper-modal{background-color:#000;opacity:.5}::ng-deep .cropper-view-box{display:block;height:100%;outline:#eee solid 1px;overflow:hidden;width:100%}::ng-deep .cropper-dashed{border:0 dashed #eee;display:block;opacity:.5;position:absolute}::ng-deep .cropper-dashed.dashed-h{border-bottom-width:1px;border-top-width:1px;height:33.33333%;left:0;top:33.33333%;width:100%}::ng-deep .cropper-dashed.dashed-v{border-left-width:1px;border-right-width:1px;height:100%;left:33.33333%;top:0;width:33.33333%}::ng-deep .cropper-center{display:block;height:0;left:50%;opacity:.75;position:absolute;top:50%;width:0}::ng-deep .cropper-center:after,::ng-deep .cropper-center:before{background-color:#eee;content:' ';display:block;position:absolute}::ng-deep .cropper-center:before{height:1px;left:-3px;top:0;width:7px}::ng-deep .cropper-center:after{height:7px;left:0;top:-3px;width:1px}::ng-deep .cropper-face,::ng-deep .cropper-line,::ng-deep .cropper-point{display:block;height:100%;opacity:.1;position:absolute;width:100%}::ng-deep .cropper-face{background-color:#fff;left:0;top:0}::ng-deep .cropper-line{background-color:#39f}::ng-deep .cropper-line.line-e{cursor:ew-resize;right:-3px;top:0;width:5px}::ng-deep .cropper-line.line-n{cursor:ns-resize;height:5px;left:0;top:-3px}::ng-deep .cropper-line.line-w{cursor:ew-resize;left:-3px;top:0;width:5px}::ng-deep .cropper-line.line-s{bottom:-3px;cursor:ns-resize;height:5px;left:0}::ng-deep .cropper-point{background-color:#39f;height:5px;opacity:.75;width:5px}::ng-deep .cropper-point.point-e{cursor:ew-resize;margin-top:-3px;right:-3px;top:50%}::ng-deep .cropper-point.point-n{cursor:ns-resize;left:50%;margin-left:-3px;top:-3px}::ng-deep .cropper-point.point-w{cursor:ew-resize;left:-3px;margin-top:-3px;top:50%}::ng-deep .cropper-point.point-s{bottom:-3px;cursor:s-resize;left:50%;margin-left:-3px}::ng-deep .cropper-point.point-ne{cursor:nesw-resize;right:-3px;top:-3px}::ng-deep .cropper-point.point-nw{cursor:nwse-resize;left:-3px;top:-3px}::ng-deep .cropper-point.point-sw{bottom:-3px;cursor:nesw-resize;left:-3px}::ng-deep .cropper-point.point-se{bottom:-3px;cursor:nwse-resize;height:20px;opacity:1;right:-3px;width:20px}@media (min-width:768px){::ng-deep .cropper-point.point-se{height:15px;width:15px}}@media (min-width:992px){::ng-deep .cropper-point.point-se{height:10px;width:10px}}@media (min-width:1200px){::ng-deep .cropper-point.point-se{height:5px;opacity:.75;width:5px}}::ng-deep .cropper-point.point-se:before{background-color:#39f;bottom:-50%;content:' ';display:block;height:200%;opacity:0;position:absolute;right:-50%;width:200%}::ng-deep .cropper-invisible{opacity:0}::ng-deep .cropper-bg{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC)}::ng-deep .cropper-hide{display:block;height:0;position:absolute;width:0}::ng-deep .cropper-hidden{display:none!important}::ng-deep .cropper-move{cursor:move}::ng-deep .cropper-crop{cursor:crosshair}::ng-deep .cropper-disabled .cropper-drag-box,::ng-deep .cropper-disabled .cropper-face,::ng-deep .cropper-disabled .cropper-line,::ng-deep .cropper-disabled .cropper-point{cursor:not-allowed}::ng-deep .cropper-line,::ng-deep .cropper-point,::ng-deep .cropper-point.point-se::before{background-color:#eee}`],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CropperComponent),
      multi: true
    }
  ],
})
export class CropperComponent implements OnDestroy, ControlValueAccessor {

  @Output() crop = new EventEmitter<CustomEvent>();
  @Output() cropMove = new EventEmitter<CustomEvent>();
  @Output() cropStart = new EventEmitter<CustomEvent>();
  @Output() cropEnd = new EventEmitter<CustomEvent>();
  @Output() ready = new EventEmitter<CustomEvent>();
  @Output() zoom = new EventEmitter<CustomEvent>();
  @Output() init = new EventEmitter<Cropper>();
  @Output() fail = new EventEmitter<Error>();
  @Output() fileChange = new EventEmitter<File>();

  @Input() options = {} as CropperOptions;

  get imageFile(): File {
    return this.originalFile;
  }

  @Input('imageFile') set imageFile(value: File) {
    delete this.dataUrl;
    this.destroyCropperIfExists();

    if (!value) {
      return;
    }

    if (['image/gif', 'image/jpeg', 'image/png'].indexOf(value.type) === -1) {
      this.fail.emit(new Error('Invalid input file type'));
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.dataUrl = reader.result;
    };

    this.originalFile = value;
    reader.readAsDataURL(this.originalFile);
  }

  @Input('imageUrl') set imageUrl(value: string) {
    delete this.dataUrl;
    this.destroyCropperIfExists();

    if (!value) {
      return;
    }

    this.dataUrl = value;
  }

  dataUrl: string|SafeUrl;
  private cropper: Cropper;
  private isReady: boolean;
  private originalFile: File;
  private data = {} as Cropper.SetDataOptions;

  propagateChange = (value: Cropper.SetDataOptions) => value;

  writeValue(value: Cropper.SetDataOptions) {
    this.data = value;

    if (this.data && this.cropper) {
      this.cropper.setData(this.data);
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  ngOnDestroy() {
    this.destroyCropperIfExists();
  }

  onImageLoad(event: Event) {
    const img = event.target as HTMLImageElement;

    this.destroyCropperIfExists();

    if ((this.options.minCropWidth && img.naturalWidth < this.options.minCropWidth)
      || (this.options.minCropHeight && img.naturalHeight < this.options.minCropHeight)) {
      delete this.dataUrl;
      this.fail.emit(new Error('Input image is too small'));
      return;
    }

    this.isReady = false;
    this.cropper = new Cropper(img, Object.assign({
      crop: this.onCrop.bind(this),
      cropmove: this.onCropMove.bind(this),
      cropstart: this.onCropStart.bind(this),
      cropend: this.onCropEnd.bind(this),
      ready: this.onReady.bind(this),
      zoom: this.onZoom.bind(this),
    }, this.options));

    this.init.emit(this.cropper);
  }

  private onCrop(event: CustomEvent) {
    if (this.options.viewMode !== 0) {
      this.correctCropArea();
    }

    if (this.isReady) {
      this.update();
    }

    this.crop.emit(event);
  }

  private onCropMove(event: CustomEvent) {
    if (this.options.viewMode === 0) {
      this.correctCropArea();
    }

    this.update();
    this.cropMove.emit(event);
  }

  private onCropStart(event: CustomEvent) {
    this.update();
    this.cropStart.emit(event);
  }

  private onCropEnd(event: CustomEvent) {
    this.correctCropArea();
    this.updateFile();
    this.update();
    this.cropEnd.emit(event);
  }

  private onReady(event: CustomEvent) {
    if (this.data) {
      this.cropper.setData(this.data);
      this.correctCropArea();
    } else {
      this.correctCropArea();
      this.update();
    }

    this.isReady = true;
    this.ready.emit(event);
    this.updateFile();
  }

  private onZoom(event: CustomEvent) {
    this.update();
    this.zoom.emit(event);
  }

  private updateFile() {
    let name = 'cropped_file';

    if (typeof this.dataUrl === 'string') {
      const urlParams = this.dataUrl.split('/');
      name = urlParams[urlParams.length - 1];
    }


    const mimeType = (this.options.outputOptions && this.options.outputOptions.mimeType) || 'image/png';
    const qualityArgument = (this.options.outputOptions && this.options.outputOptions.qualityArgument) || 0.9;

    this.cropper.getCroppedCanvas().toBlob((blob: any) => {
      blob.lastModifiedDate = new Date();
      blob.name = this.originalFile ? this.originalFile.name : name;
      this.fileChange.emit(blob);
    }, mimeType, qualityArgument);
  }

  private correctCropArea() {
    const data = this.cropper.getData();

    if (data.height < this.options.minCropHeight || data.width < this.options.minCropWidth) {
      data.width = Math.max(data.width, this.options.minCropWidth || 0);
      data.height = Math.max(data.height, this.options.minCropHeight || 0);
      this.cropper.setData(data);
    }
  }

  private update() {
    this.data = this.cropper.getData();
    this.propagateChange(this.data);
  }

  private destroyCropperIfExists() {
    if (!this.cropper) {
      return;
    }

    this.cropper.destroy();
    delete this.cropper;
  }

}
